import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAssetType($companyId: ID!, $attributes: AssetTypeAttributes!) {
    createAssetType(companyId: $companyId, attributes: $attributes) {
       assetType {
        id
        ...CreatedAssetType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAssetType on AssetType {
    id
    manufacturer
    description
    weight
    costCents
    displayOnWebsite
    model
    rateCents
    availableToEvents
  }
`
